import { generateId } from './timeHelpers';
import {
  getCurrentCareTime,
  getDefaultCareDayOffset,
  getLateEntryDetails,
  normalizeCareTime,
} from './lateEntry';

import { formatClinicalDateTime } from '../i18n/localeFormat';

export function getNoteAddendums(note) {
  if (!note) return [];
  const list = note.addendums || note.note_content?.addendums || note.openaiNote?.addendums;
  return Array.isArray(list) ? list : [];
}

export function formatAddendumAddedAt(iso, language = 'en') {
  if (!iso) return '—';
  return formatClinicalDateTime(iso, language) || '—';
}

/**
 * Build a new addendum record attached to an existing saved note.
 */
export function createAddendum({
  originalNoteId,
  text,
  careTime,
  careDayOffset = null,
  now = new Date(),
}) {
  const addendumTime = now instanceof Date ? now.toISOString() : String(now);
  const addendumCareTime = normalizeCareTime(careTime) || getCurrentCareTime(now);
  const offset =
    careDayOffset === 0 || careDayOffset === 1
      ? careDayOffset
      : getDefaultCareDayOffset(now);
  const details = getLateEntryDetails(addendumCareTime, addendumTime, offset);

  return {
    id: generateId(),
    original_note_id: originalNoteId,
    addendum_text: String(text || '').trim(),
    addendum_time: addendumTime,
    addendum_care_time: addendumCareTime,
    care_day_offset: offset,
    is_late_entry: details.isLateEntry,
    late_entry_diff_minutes: details.diffMinutes,
  };
}

export function attachAddendumToNote(note, addendum) {
  if (!note || !addendum?.addendum_text) return note;
  const existing = getNoteAddendums(note);
  const nextAddendums = [...existing, addendum];

  const nextContent = {
    ...(note.note_content || note.openaiNote || {}),
    addendums: nextAddendums,
  };

  return {
    ...note,
    addendums: nextAddendums,
    note_content: nextContent,
    openaiNote: {
      ...(note.openaiNote || note.note_content || {}),
      addendums: nextAddendums,
    },
  };
}
